export const accessToken = "accessToken";
export const activeTeamId = "activeTeamId";
export const activeTeamIdForNewTabs = "activeTeamIdForNewTabs";
